import React from 'react';
import './Campaign.scss';
import Item from '../item/Item';
import Parse from "parse";
import Rodal from 'rodal';
import * as QueryString from "query-string";
import { withRouter } from "react-router";

// include styles
import 'rodal/lib/rodal.css';

const RAINBOW = ['#e53935','#f57c00','#ff8f00','#43a047','#00897b','#1e88e5','#8e24aa'];
function rainbowText(text) {
    let colorIdx = 0;
    return text.split('').map((ch, i) =>
        ch === ' '
            ? <span key={i}>&nbsp;</span>
            : <span key={i} style={{ color: RAINBOW[colorIdx++ % RAINBOW.length] }}>{ch}</span>
    );
}

class Campaign extends React.Component {
    constructor() {
        super();

        this.state = {
            items: [],
            selections: { "Total": 0, "VBS1": 0, "VBS2": 0, "VBS3": 0, "VBS4": 0 },
            isItemsLoaded: false,
            isItemsRemaining: true,
            isWelcomeAcknowledged: false,
            showInstructions: true,
            itemModal: { visible: false, item: {}, groupItems: [], selections: {} },
            thankYouModal: { visible: false, count: 0, savedCount: 0, text: '' }
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    reloadCampaign() {
        var that = this;
        var Item = Parse.Object.extend("GemStone");

        var itemsQuery = new Parse.Query(Item);
        itemsQuery.equalTo('Hidden', false);
        itemsQuery.ascending('Group');
        itemsQuery.addAscending('Number');
        itemsQuery.limit(500);
        itemsQuery.find().then(function(items){
            // Check if item reserved stasuses have expired.
            var now = new Date().getTime();
            for (const property in items) {
                var item = items[property];
                if (item.get("Status") === 'Reserved') {
                    var itemTime = item.get("updatedAt").getTime();
                    if ((now - itemTime) > 300000) { // 5 minute differential
                        item.set("Status", 'Available');
                        item.save();
                    }
                }
            }
            var //itemsArray = JSON.parse(JSON.stringify(items)),
                isItemsRemaining = false;

            for (const property in items) {
                var item2 = items[property];
                if (item2.get("Status") !== 'Taken') {
                    isItemsRemaining = true;
                    break;
                }
            }

            that.setState({
               isItemsLoaded: true,
               isItemsRemaining: isItemsRemaining,
               items: items
            });
        }).catch(function(error){
            console.log("Error: " + error.code + " " + error.message);       
        });
    }

    componentDidMount() {
        var Item = Parse.Object.extend("GemStone"),
            that = this;

        // Load the items within the campaign.
        this.reloadCampaign();

        const params = QueryString.parse(this.props.location.search);
        if (params.SelectedItems) {
            // Receive redirect from Cognito Form with taken item details.
            var selectedItems = params.SelectedItems.split(","),
                takenByEmail = params.TakenByEmail,
                submissionId = params.SubmissionId,
                inviting = params.Inviting,
                serving = params.Serving,
                attending = params.Attending,
                giving = params.Giving,
                servingCount = params.ServingCount,
                attendingAdults = params.AttendingAdults,
                // attendingChildren = params.AttendingChildren,
                takenItems = [],
                prizeItems = [];
            
            // Note: The user may have adjusted their selections on the form, so we need to reconcile the difference between the original
            // selections and the adjustments while we record the official change to the items.
            var remainingCounts = {
                "Serving": (serving === 'Yes') ? parseInt(servingCount) : 0,
                "Attending": (attending === 'Yes') ? (attendingAdults ? parseInt(attendingAdults) : 0) : 0,
                "Inviting": (inviting === 'Yes') ? 1 : 0,
                "Giving": (giving === 'Yes') ? 1 : 0
            };

            var submissionQuery = new Parse.Query(Item);
            submissionQuery.equalTo('SubmissionId', submissionId);
            submissionQuery.limit(500);
            submissionQuery.find().then(function(submittedItems){

                if (submittedItems.length > 0) {
                    // Show the "thank you" modal.
                    that.setState({
                        "thankYouModal": {
                            visible: true,
                            text: "Submission already applied.",
                            count: -1,
                            prizeCount: 0
                        },
                        isWelcomeAcknowledged: true,
                        showInstructions: false
                    });
                }
                else {

                    var itemsQuery = new Parse.Query(Item);
                    // itemsQuery.matches('Status', 'Available');
                    itemsQuery.ascending('Group');
                    itemsQuery.addAscending('Number');
                    itemsQuery.limit(500);
                    itemsQuery.find().then(function(items){

                        // Pick which originally taken items are still taken.
                        for (const key in items) {
                            const item = items[key];
                            
                            selectedItems.forEach(function(value, index, array) {
                                if (value !== "") {
                                    if (item.id === value && item.get('Status') !== 'Taken' && remainingCounts[item.get('Group')] > 0) {
                                        remainingCounts[item.get('Group')]--;
                                        takenItems.push(item);
                                        if (item.get('Type') === 'G') {
                                            prizeItems.push(item);
                                        }
                                    }
                                }
                            });
                        }

                        // Pick additional items from the top as needed.
                        for (const key in items) {
                            var item = items[key];

                            if (remainingCounts[item.get('Group')] > 0 && item.get('Status') === 'Available') {
                                remainingCounts[item.get('Group')]--;
                                takenItems.push(item);
                                if (item.get('Type') === 'G') {
                                    prizeItems.push(item);
                                }
                            }

                        }

                        // Save all the taken items.
                        takenItems.forEach(function(value, index, array) {

                            value.set("Status", 'Taken');
                            value.set("TakenByEmail", takenByEmail);
                            value.set("SubmissionId", submissionId);
                            value.save();

                        });

                        // Show the "thank you" modal.
                        that.setState({
                            "thankYouModal": {
                                visible: true,
                                text: "Applied.",
                                count: takenItems.length,
                                prizeCount: prizeItems.length
                            },
                            isWelcomeAcknowledged: true,
                            showInstructions: false
                        });
                    });
                }
            });
        }
        else if (params.acknowledged) {
            this.setState({
                isWelcomeAcknowledged: true,
                showInstructions: false
            });
        }
    }

    changeHandler = event => {
        const name = event.target.getAttribute('id');
        const value = event.target.value;
        if (!value || value === "") {            
            this.setState({
                [`${name}Error`]: true
            })
        } else { 
            this.setState({
                [`${name}Error`]: false,
                [name]: value
            })
        }
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        try{
            await Parse.User.logIn(this.state.username, this.state.password);
            alert("Logged in!");
        } catch (e){
            alert(e.message); 
        }
        
    }

    selectItem(selectedItem) {
        var that = this;
        var Item = Parse.Object.extend("GemStone");

        var query = new Parse.Query(Item);
        query.get(selectedItem.id)
        .then((item) => {
            var selections = that.state.selections,
                group = item.get("Group");
            // The object was retrieved successfully and it is ready to update.
            if (selectedItem.get("Status") === 'Available') {
                if (item.get("Status") === 'Available') {
                    // if ((group === 'Giving' || group === 'Inviting') && selections[group] > 0) {
                    //     alert("This category is limited to 1 selection.");
                    // }
                    // else if (selections[group] >= 6) {
                    //     alert("This category is limited to 6 selections.");
                    // }
                    // else {
                        item.set("Status", 'Reserved');
                        item.save();
                        selectedItem["selected"] = true;
                        
                        selections["Total"]++;
                        selections[group]++;
                        
                    // }
                }
                else {
                    selectedItem.set("Status", item.get("Status"));
                    alert("This one is already taken. Please find another PALM BUSH!");
                }
            }
            else if (selectedItem["selected"]) {
                if (item.get("Status") === 'Reserved') {
                    selectedItem.set("Status", 'Available');
                    item.set("Status", 'Available');
                    // item.set("TakenByEmail", takenByEmail);
                    item.save();
                    selections["Total"]--;
                    selections[item.get("Group")]--;
                    selectedItem["selected"] = false;
                }
                else {
                    selectedItem.set("Status", item.get("Status"));
                }
            }
            else {
                selectedItem.set("Status", item.get("Status"));
                alert("Oops, you selected a RAINFOREST item.  Please find a GREEN PALMBUSH!");
            }
            
            that.setState({
                selections: selections
            });
            // that.forceUpdate();
        }, (error) => {
            // The object was not retrieved successfully.
        });

    }

    closeItemModal() {
        this.reloadCampaign();
        this.setState({ itemModal: { visible: false, item: {}, groupItems: [], selections: {} } });
    }

    closeThankYouModal() {
        window.location = window.location.pathname + "?acknowledged=true";
        // // Reload the items of the campaign (after 2 seconds);
        // var that = this;
        // setTimeout(function(){ that.reloadCampaign(); }, 2000);
        
        // // Close modal.
        // this.setState({ thankYouModal: { visible: false, text: '', count: 0, prizeCount: 0 } });
    }

    proceedToForm(selections) {

        // var entryJson = {
        //     "GivingSection": { "Giving": (selections.VBS1 > 0) },
        //     "ServingSection": { "Serving": (selections.VBS > 0), "ServingCount": selections.Serving },
        //     "AttendingSection": { "Attending": (selections.Attending > 0), "AttendingAdults": selections.Attending },
        //     "InvitingSection": { "Inviting": (selections.Inviting > 0) },
        //     "SelectedItems": ""
        // };

        var that = this;

        this.setState({
            selections: { "Total": 0, "VBS1": 0, "VBS2": 0, "VBS3": 0, "VBS4": 0 }
        });

        // Gather selected items.
        var selectedCount = 0;
        // Save all the taken items.
        this.state.items.forEach(function(value, index, array) {
            if (value["selected"]) {
                value.set("Status", 'Taken');
                // value.set("TakenByEmail", takenByEmail);
                // value.set("SubmissionId", submissionId);
                value.save();
                value["selected"] = false;
                selectedCount++;
            }
            that.forceUpdate();
        });
        // this.reloadCampaign();
        // window.location = 'https://www.cognitoforms.com/RestorationChurch3/The30303030Campaign?entry=' + JSON.stringify(entryJson);
        window.open("https://restorationchurchpa.churchcenter.com/giving/to/vbs?default_amount=" + (selectedCount * 10));
    }

    acknowledgeWelcome() {
        this.setState({ isWelcomeAcknowledged: true } );
    }

    render() {
        if (!this.state.isWelcomeAcknowledged) {
            return (
                <div id="campaign">  
                    <Rodal height={750} visible={!this.state.isWelcomeAcknowledged} showCloseButton={false} /*onClose={this.acknowledgeWelcome.bind(this)}*/>

                            {/* <h3 className="text-center">The 120-in-2021 campaign is now closed.</h3>
                            <p>
                                We thank everyone who made a pledge during the 120-in-2021 campaign!  Through your support, we not only met but surpassed our goals.  Thank you!
                            </p>
                            <p>    
                                Although this campaign has ended, our mission at Restoration Church continues with even greater commitment.  If you would like to learn more about Restoration Church and contribute to our mission, please visit our web site: <a href="http://www.restorationchurchpa.org">www.restorationchurchpa.org</a>.
                            </p> */}
                            {/* <div className="text-center m-t-2">
                                <button className="button button--block button--primary" onClick={this.acknowledgeWelcome.bind(this)}>View Campaign Results</button>
                            </div> */}

                            <h3 className="text-center">VBS 2026 @ RESTORATION</h3>
                            {this.state.isItemsRemaining &&
                                <span>
                                <p>
                                    <span className="center">
                                        <span className="character character-welcome"></span>
                                    </span>
                                    Hello Restoration Church!  My name is Caper, and I am super excited to be a part of this year's VBS -- "Rainforest Falls"!
                                    This year, our kids will be Exploring the Nature of God!
                                </p>
                                <p>
                                    Thank you for your interest in supporting VBS at Restoration.
                                    Each $10 donation we receive will help provide unique materials for a hands-on experience for every VBS kid.
                                </p>
                                <p>
                                    On the next screen, choose your donation amount by selecting one <span className="green">PALMBUSH</span> for each $10 donation.
                                    Once your donation is confirmed, each <span className="green">PALMBUSH</span> will reveal the <span className="rainbow">{rainbowText('COLORFUL RAINFOREST')}</span>.
                                    Together, we will provide a message of love and hope to every child.
                                </p>
                                </span>
                            }
                            {!this.state.isItemsRemaining &&
                                <p>
                                    All slots in the campaign are full (this is good news!).  But check back soon, as we will be adding more slots as needed.
                                </p>
                            }
                            <div className="text-center m-t-2">
                                <button className="button button--block button--primary" onClick={this.acknowledgeWelcome.bind(this)}>Get Started</button>
                            </div>
                    
                    </Rodal>
            </div>

            );
        } else if (!this.state.isItemsLoaded) {
          return <div id="campaign">Loading...</div>;
        } else {
            return (
            
                <div id="campaign">

                    <Rodal height={600} visible={this.state.thankYouModal.visible} onClose={this.closeThankYouModal.bind(this)}>
                        <h3>Thank You!</h3>

                        {this.state.thankYouModal.count === -1 &&
                            <p>Your submission has already been processed. Thank you for making a difference in reaching more lives at Restoration Church!</p>
                        }

                        {this.state.thankYouModal.count > 0 &&
                            <span>
                                <p>Thank you for {this.state.thankYouModal.count > 1 && <span>the {this.state.thankYouModal.count} commitments</span>}{this.state.thankYouModal.count === 1 && <span>the commitment</span>} you have made!</p>
                                <p>The stories of life change, discovered hope, and freedom in Christ at Restoration are now  <em>your stories</em>.</p>
                                {this.state.thankYouModal.prizeCount === 0 &&
                                    <p>You did not pick a golden mug, but we hope you had fun trying. Continue to see the difference you have made towards reaching our goal!</p>
                                }
                                {this.state.thankYouModal.prizeCount > 0 &&
                                    <p>CONGRATULATIONS! You uncovered a golden mug! We'll be in touch with you about selecting an item of your choice from the Restoration store when it reopens.</p>
                                }
                            </span>
                        }

                        <div className="text-center m-t-2">
                            <button className="button button--primary button--block" onClick={this.closeThankYouModal.bind(this)}>Continue</button>
                        </div>
                    </Rodal>

                    <div className="campaign-container">

                        <div className="campaign-logo"></div>

                        <div className="item-group item-group-1">
                            {/* <div className="header">Give</div>
                            <div className="subheader">Goal: 30 giving units to begin giving or raise their giving.</div> */}
                            {this.state.items.map((item, index) => item.get("Group") === 'VBS1' &&
                                <Item className="item" key={index} index={item.get("Number")} onSelect={this.selectItem.bind(this)} item={item} />
                            )}
                        </div>

                        <div className="item-group item-group-2">
                            {/* <div className="header">Serve RC Kids</div>
                            <div className="subheader">Goal: 30 volunteers to help in RC kids to restart this vital ministry.</div> */}
                            {this.state.items.map((item, index) => item.get("Group") === 'VBS2' &&
                                <Item className="item" key={index} index={item.get("Number")} onSelect={this.selectItem.bind(this)} item={item} />
                            )}
                        </div>

                        <div className="item-group item-group-3">
                            {/* <div className="header">Attend</div>
                            <div className="subheader">Goal: 30 adults to return to in-person services starting Easter.</div> */}
                            {this.state.items.map((item, index) => item.get("Group") === 'VBS3' &&
                                <Item className="item" key={index} index={item.get("Number")} onSelect={this.selectItem.bind(this)} item={item} />
                            )}
                        </div>

                        <div className="item-group item-group-4">
                            {/* <div className="header">Invite</div>
                            <div className="subheader">Goal: 30 people to commit to being an inviter.</div> */}
                            {this.state.items.map((item, index) => item.get("Group") === 'VBS4' &&
                                <Item className="item" key={index} index={item.get("Number")} onSelect={this.selectItem.bind(this)} item={item} />
                            )}
                        </div>

                    </div>
                
                    {this.state.selections.Total > 0 &&
                        <button className="button button--primary button--block button--continue" onClick={this.proceedToForm.bind(this, this.state.selections)}>
                            <span>Continue with ${this.state.selections.Total * 10} Donation &gt;&gt;</span>
                        </button>
                    }

                    {this.state.selections.Total === 0 && this.state.showInstructions &&
                        <div className="instructions">
                            <span className="character character-block"></span>
                            <span className="text">Select a <span className ="green">PALMBUSH</span> for each $10 donation that you would like to make.</span>
                        </div>
                    }

                </div>
            );
        }
    }
}

export default withRouter(Campaign);
